import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import '@mdi/font/css/materialdesignicons.css'
import {computed} from "vue";

interface Props {
  icon?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogIcon',
  props: {
    icon: { default: undefined }
  },
  setup(__props: any) {


const props = __props

const _class = computed(() => {
  if (props.icon) {
    return "sog-icon mdi-set " + props.icon
  }
  return "sog-icon mdi-set"
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_class.value)
  }, null, 2))
}
}

})